import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const BillingAndPayments = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_7122_762)">
          <path
            d="M17.3789 21.9598V4.04419L19.7026 6.80563L21.1338 5.22285L22.8344 7.51282L24.581 5.8627L26.5831 8.35472L28.7277 6.80563V26.6071L26.5831 23.3742L24.581 24.856L23.0533 21.9598L20.7981 23.3742L19.4342 20.6128L17.3789 21.9598Z"
            fill="white"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.0898 11.251C20.5064 11.251 20.8442 10.9133 20.8442 10.4967C20.8442 10.08 20.5064 9.74231 20.0898 9.74231C19.6732 9.74231 19.3355 10.08 19.3355 10.4967C19.3355 10.9133 19.6732 11.251 20.0898 11.251ZM20.0902 14.4836C20.5068 14.4836 20.8445 14.1459 20.8445 13.7293C20.8445 13.3127 20.5068 12.9749 20.0902 12.9749C19.6736 12.9749 19.3359 13.3127 19.3359 13.7293C19.3359 14.1459 19.6736 14.4836 20.0902 14.4836ZM20.0898 17.7165C20.5064 17.7165 20.8441 17.3788 20.8441 16.9622C20.8441 16.5456 20.5064 16.2078 20.0898 16.2078C19.6732 16.2078 19.3354 16.5456 19.3354 16.9622C19.3354 17.3788 19.6732 17.7165 20.0898 17.7165Z"
            fill="#2B2F38"
          />
          <path
            d="M22.1946 11.0825L26.1347 12.2275"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.1946 14.5848L26.1347 15.7298"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.1946 17.8513L26.1347 18.9963"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="6.11333"
            y="14.5788"
            width="18.6709"
            height="12.6709"
            rx="1.3"
            fill="#FB6434"
            stroke="#2B2F38"
            strokeWidth="1.4"
          />
          <rect
            x="7.15415"
            y="9.70998"
            width="18.6709"
            height="13.1481"
            rx="1.3"
            transform="rotate(15.2124 7.15415 9.70998)"
            fill="#F8B200"
            stroke="#2B2F38"
            strokeWidth="1.4"
          />
          <path
            d="M18.7839 22.386C18.5867 23.111 17.8391 23.539 17.1141 23.3418C16.3891 23.1447 15.9611 22.3971 16.1583 21.672C16.3554 20.947 17.103 20.5191 17.828 20.7162C18.5531 20.9134 18.981 21.661 18.7839 22.386Z"
            fill="#2B2F38"
          />
          <path
            d="M20.8247 22.9411C20.6276 23.6661 19.88 24.094 19.155 23.8969C18.4299 23.6997 18.002 22.9521 18.1992 22.2271C18.3963 21.5021 19.1439 21.0741 19.8689 21.2713C20.594 21.4684 21.0219 22.216 20.8247 22.9411Z"
            fill="#2B2F38"
          />
          <path
            d="M7.54688 19.3304L13.4612 20.9387"
            stroke="#2B2F38"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="6.71906"
            y="12.6208"
            width="17.8146"
            height="3.26092"
            transform="rotate(15.2124 6.71906 12.6208)"
            fill="#2B2F38"
          />
        </g>
        <defs>
          <clipPath id="clip0_7122_762">
            <rect width="32" height="32" fill="white" transform="translate(0.979492 0.356689)" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default BillingAndPayments
